export var SortColumnKey;
(function (SortColumnKey) {
    SortColumnKey["FeatureName"] = "FEATURE_NAME";
})(SortColumnKey || (SortColumnKey = {}));
export var FeatureAccessTab;
(function (FeatureAccessTab) {
    FeatureAccessTab["GeneralAccess"] = "general_access";
    FeatureAccessTab["EarlyAccess"] = "early_access";
})(FeatureAccessTab || (FeatureAccessTab = {}));
const DATA_MODELLING_CATEGORY = 'dataModelling';
const DATA_MODELLING_FEATURE_TITLE_KEY = 'isTmlUtilityV2Enabled.title';
export const getFeatureDisplayName = (feature, t) => feature.category === DATA_MODELLING_CATEGORY
    ? t(DATA_MODELLING_FEATURE_TITLE_KEY)
    : feature.name;
//# sourceMappingURL=feature-management.util.js.map